import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "../style/ProjectDetailsSection.scss";
import projectsData from "../data/projects.json";

const ProjectDetailsSection = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    const found = projectsData.find((p) => p.documentId === id);
    setProject(found || null);
  }, [id]);

  if (!project) {
    return (
      <section className="project-details error">
        <div className="error-container">
          <h2>Project Not Found</h2>
          <p>The project you're looking for doesn't exist.</p>
          <Link to="/Showcase" className="back-button">
            ← Back to Projects
          </Link>
        </div>
      </section>
    );
  }
const { title, category, year, description, logo, Toolsnologies, gallery, liveUrl } = project;
const technologies = Toolsnologies || [];
  
  const galleryImages = gallery || [];
 

  const handleNextImage = () => {
    if (galleryImages.length > 0) {
      setActiveImageIndex((prev) => (prev + 1) % galleryImages.length);
    }
  };

  const handlePrevImage = () => {
    if (galleryImages.length > 0) {
      setActiveImageIndex((prev) =>
        prev === 0 ? galleryImages.length - 1 : prev - 1
      );
    }
  };

  const handleThumbnailClick = (index) => setActiveImageIndex(index);

  return (
    <section className="project-details">
      <div className="back-nav">
        <Link to="/Showcase" className="back-button">← Back to Projects</Link>
      </div>

      <div className="project-header">
        <div className="project-meta">
          <span className="project-year">{year}</span>
          <span className="project-category">⚡ {category}</span>
        </div>

        <h1 className="project-title">{title}</h1>

        {logo && (
          <div className="project-logo-large">
            <img src={logo} alt={`${title} Logo`} />
          </div>
        )}

        {liveUrl && (
          <a href={liveUrl} target="_blank" rel="noopener noreferrer" className="live-site-button">
            🌐 View Live Website
          </a>
        )}
      </div>

      <div className="project-content">
        <div className="project-description">
          <h2>Project Overview</h2>
          <div className="description-content">
            {description?.split("\n").map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>

       {technologies.length > 0 && (
          <div className="project-technologies">
          <h2>Technologies Used</h2>
          <div className="technologies-grid">
          {technologies.map((tech, index) => (
          <div key={index} className="tech-badge">
          <img src={tech.url} alt={tech.name} title={tech.name} />
          </div>
          ))}
          </div>
          </div>
          )}

        {galleryImages.length > 0 && (
          <div className="project-gallery">
            <div className="gallery-main">
              <img
                src={galleryImages[activeImageIndex]?.url}
                alt={`${title} - View ${activeImageIndex + 1}`}
                className="gallery-active-image"
              />
              {galleryImages.length > 1 && (
                <>
                  <button className="gallery-nav prev" onClick={handlePrevImage}>←</button>
                  <button className="gallery-nav next" onClick={handleNextImage}>→</button>
                  <div className="gallery-counter">
                    {activeImageIndex + 1} / {galleryImages.length}
                  </div>
                </>
              )}
            </div>

            {galleryImages.length > 1 && (
              <div className="gallery-thumbnails">
                {galleryImages.map((image, index) => (
                  <button
                    key={image.id}
                    className={`thumbnail ${index === activeImageIndex ? "active" : ""}`}
                    onClick={() => handleThumbnailClick(index)}
                  >
                    <img src={image.url} alt={`Thumbnail ${index + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProjectDetailsSection;